export default {
  namespaced: true,

  state: {
    token: '',
    user: null,
    userID: 0,
    businessID: 0,
    userRights: [],
    isLoggedIn: false,
    userType: 0,
    roles: null,
    authRoutes: {},
    passEntered: '',
  },

  getters: {
    isAuthenticated: (state) => !!state.token && !!state.user,
    currentUser: (state) => state.user,
    userID: (state) => state.userID,
    businessID: (state) => state.businessID || 1,
    userRights: (state) => state.userRights,
    hasUserRight: (state) => (right) => {
      return state.userRights.includes(right);
    },
    // Check if user is admin
    isAdmin: (state) => {
      const isAdmin =
        state.user &&
        (state.user.email === 'admin@invoice.com' || state.user.username === 'admin@invoice.com');

      return isAdmin;
    },
  },

  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      if (token) state.isLoggedIn = true;
    },

    SET_USER(state, user) {
      state.user = user;
      if (user) {
        state.userID = user.id;
        state.userType = user.userType || 0;
        state.isLoggedIn = true;
      }
    },

    SET_USER_ID(state, id) {
      state.userID = id;
    },

    SET_BUSINESS_ID(state, id) {
      state.businessID = id;
    },

    SET_USER_RIGHTS(state, rights) {
      state.userRights = rights;
    },

    SET_AUTH_ROUTES(state, routes) {
      state.authRoutes = routes;
    },

    SET_PASS_ENTERED(state, pass) {
      state.passEntered = pass;
    },

    LOGOUT(state) {
      state.token = '';
      state.user = null;
      state.userID = 0;
      state.businessID = 0;
      state.userRights = [];
      state.isLoggedIn = false;
      state.userType = 0;
      state.roles = null;
      state.authRoutes = {};
      state.passEntered = '';
    },
  },

  actions: {
    login({ commit }, userData) {
      commit('SET_TOKEN', userData.token);
      commit('SET_USER', userData.user);
      commit('SET_BUSINESS_ID', userData.user.businessID);

      // Parse forms data as JSON if it's a string
      if (userData.user.forms) {
        const formsData =
          typeof userData.user.forms === 'string'
            ? JSON.parse(userData.user.forms)
            : userData.user.forms;

        commit('SET_USER_RIGHTS', formsData);
      }
    },

    logout({ commit }) {
      commit('LOGOUT');
    },
  },
};
